import React, { useCallback } from 'react';
import Button from '@prisjakt/ui-button';
import Dropdown from '@prisjakt/ui-dropdown-new';
import CogWheel from 'mdi-react/SettingsIcon';

import * as S from './styles';

import { SidebarHeaderOption } from '../sharedTypes';

type Props = {
  title: string;
  onClickHandler?: () => void;
  options?: SidebarHeaderOption[];
  settingsIcon?: React.ReactNode;
  useDropdown?: boolean;
};

const SidebarHeader = ({
  title,
  onClickHandler,
  options,
  settingsIcon,
  useDropdown,
}: Props) => {
  const onEditClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();

      return options && options[0].handler();
    },
    [options]
  );

  return (
    <S.SidebarHeader onClick={onClickHandler}>
      <S.LeftArrow />
      <S.HeaderTitle hasMargin={!options}>{title}</S.HeaderTitle>

      {options && (options.length > 1 || useDropdown) && (
        <Dropdown
          variant="secondary"
          grow="left"
          toggleElement={
            <S.SettingsButton>
              <Button
                variant="icon"
                icon={
                  <S.SettingsIcon component={settingsIcon || <CogWheel />} />
                }
              />
            </S.SettingsButton>
          }
          showArrow={false}
        >
          {options.map(option =>
            option && option.title && option.handler ? (
              <S.OptionButton type="button" onClick={option.handler}>
                {option.title}
              </S.OptionButton>
            ) : null
          )}
        </Dropdown>
      )}

      {options && (options.length === 1 && !useDropdown) && (
        <S.SettingsButton>
          <Button
            variant="icon"
            icon={<S.SettingsIcon component={settingsIcon || <CogWheel />} />}
            onClick={onEditClick}
          />
        </S.SettingsButton>
      )}
    </S.SidebarHeader>
  );
};

export default SidebarHeader;
